import React, { useState } from "react";
import TabBar from "./TabBar";
import Users from "./Users";
import Purchases from "./Purchases";

const User = () => {
  const [activeTab, setActiveTab] = useState("users");

  return (
    <div className="w-full md:ml-[4.4rem] px-4 md:px-8 lg:px-10 mt-20 bg-main-bg min-h-screen pb-12">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500;600&display=swap');
        * { font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif; }
        .mono { font-family: 'JetBrains Mono', monospace; }
        .stat-card { background: linear-gradient(135deg, #2563EB 0%, #1d4ed8 100%); }
        .stat-card-success { background: linear-gradient(135deg, #10B981 0%, #059669 100%); }
        .stat-card-warning { background: linear-gradient(135deg, #F59E0B 0%, #D97706 100%); }
        .stat-card-danger { background: linear-gradient(135deg, #EF4444 0%, #DC2626 100%); }
        .stat-card-purple { background: linear-gradient(135deg, #8B5CF6 0%, #7C3AED 100%); }
      `}</style>

      <TabBar activeTab={activeTab} setActiveTab={setActiveTab} />

      {activeTab === "users" && <Users />}
      {activeTab === "purchases" && <Purchases />}
    </div>
  );
};

export default User;